import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { slotMachineIcons } from 'helpers/downWorldData.js';
import Store from 'store/store';

import s from 'components/bolt/downWorld/winResult/winResult.sss';

export default class WinResult extends Component {

	constructor(props) {
		super(props);
		this.state = {
			show : true
		};

		const homeEntEnabled = Store.get()?.appData?.options?.enableHomeEnt;
		this.slotMachineIcons = slotMachineIcons.filter(s => !(s === 'super-bell' && !homeEntEnabled));	
	}

	componentDidMount() {
		Store.on('SLOT_MACHINE_SHOW_WINNING_ICON', () => {
			this.setState({ show: true });
		});
		Store.on('SLOT_MACHINE_HIDE_WINNING_ICON', () => { 
			this.setState({ show: false });
		});
	}

	componentWillUnmount() {
		Store.off('SLOT_MACHINE_ANIM_COMPLETE');
		Store.off('SLOT_MACHINE_HIDE_WINNING_ICON');
	}

	render({ imageRoot, winningIcon, lastWinningIcon }) {
		return (
			<div class={s.container}>
				{this.slotMachineIcons.map(icon => (
					<img
						class={
							joinClasses(
								s.icon,
								icon === winningIcon && s.winningIcon,
								icon === lastWinningIcon && s.lastWinningIcon,
								this.state.show && s.show
							)}
						src={`${imageRoot}/down/slot-machine-icons/winning/${icon}.webp`}
					/>
				))}
			</div>
		);
	}
}